export const toolCategories = [
  // Developer Tools
  {
    id: 'developer',
    name: 'Developer Tools',
    description: 'Essential tools for developers to streamline their workflow',
    icon: '💻',
    tools: [
      // JSON Tools
      {
        id: 'json-formatter',
        name: 'JSON Formatter',
        description: 'Format, validate, and minify JSON data with syntax highlighting',
        path: '/tools/json-formatter',
        keywords: ['json', 'formatter', 'validator', 'beautifier', 'minify', 'format']
      },
      {
        id: 'json-prettify',
        name: 'JSON Prettify',
        path: '/tools/json-prettify',
        description: 'Format and beautify JSON data with proper indentation',
        keywords: ['json', 'prettify', 'beautifier', 'format']
      },
      {
        id: 'json-minify',
        name: 'JSON Minify',
        path: '/tools/json-minify',
        description: 'Minify JSON by removing unnecessary whitespace',
        keywords: ['json', 'minify', 'compress', 'optimize']
      },
      // HTML Tools
      {
        id: 'html-prettify',
        name: 'HTML Prettify',
        path: '/tools/html-prettify',
        description: 'Format and beautify HTML code with proper indentation',
        keywords: ['html', 'formatter', 'beautifier', 'prettify']
      },
      {
        id: 'html-formatter',
        name: 'HTML Formatter',
        path: '/tools/html-formatter',
        description: 'Format and beautify HTML code with proper indentation',
        keywords: ['html', 'formatter', 'beautifier', 'prettify']
      },
      {
        id: 'html-minify',
        name: 'HTML Minify',
        path: '/tools/html-minify',
        description: 'Minify HTML by removing unnecessary whitespace and comments',
        keywords: ['html', 'minify', 'compress', 'optimize']
      },
      // CSS Tools
      {
        id: 'css-prettify',
        name: 'CSS Formatter',
        path: '/tools/css-prettify',
        description: 'Format and beautify CSS code with proper indentation',
        keywords: ['css', 'formatter', 'beautifier', 'prettify']
      },
      {
        id: 'css-minify',
        name: 'CSS Minify',
        path: '/tools/css-minify',
        description: 'Minify CSS by removing unnecessary whitespace and comments',
        keywords: ['css', 'minify', 'compress', 'optimize']
      },
      // JavaScript Tools
      {
        id: 'js-beautifier',
        name: 'JavaScript Beautifier',
        path: '/tools/js-beautifier',
        description: 'Format and beautify JavaScript code with proper indentation',
        keywords: ['javascript', 'beautifier', 'formatter', 'prettify', 'js']
      },
      {
        id: 'js-minify',
        name: 'JavaScript Minify',
        path: '/tools/js-minify',
        description: 'Minify JavaScript code by removing whitespace and optimizing',
        keywords: ['javascript', 'minify', 'compress', 'optimize', 'js']
      },
      {
        id: 'js-obfuscator',
        name: 'JavaScript Obfuscator',
        path: '/tools/js-obfuscator',
        description: 'Obfuscate JavaScript code to protect intellectual property',
        keywords: ['javascript', 'obfuscator', 'protect', 'minify', 'js']
      },
      // XML Tools
      {
        id: 'xml-prettify',
        name: 'XML Formatter',
        path: '/tools/xml-prettify',
        description: 'Format and beautify XML with proper indentation and line breaks',
        keywords: ['xml', 'formatter', 'beautifier', 'prettify']
      },
      {
        id: 'xml-minify',
        name: 'XML Minify',
        path: '/tools/xml-minify',
        description: 'Minify XML by removing unnecessary whitespace and comments',
        keywords: ['xml', 'minify', 'compress', 'optimize']
      },
      // SQL Tools
      {
        id: 'sql-formatter',
        name: 'SQL Formatter',
        path: '/tools/sql-formatter',
        description: 'Format and beautify SQL queries with syntax highlighting',
        keywords: ['sql', 'formatter', 'beautifier', 'query', 'database']
      },
      {
        id: 'sql-minify',
        name: 'SQL Minify',
        path: '/tools/sql-minify',
        description: 'Minify SQL queries by removing unnecessary whitespace',
        keywords: ['sql', 'minify', 'compress', 'optimize', 'query']
      },
      // Other Code Tools
      {
        id: 'yaml-formatter',
        name: 'YAML Formatter',
        path: '/tools/yaml-formatter',
        description: 'Format and validate YAML with proper indentation',
        keywords: ['yaml', 'formatter', 'validator', 'beautifier']
      },
      {
        id: 'lua-beautifier',
        name: 'Lua Beautifier',
        path: '/tools/lua-beautifier',
        description: 'Format and beautify Lua code with proper indentation',
        keywords: ['lua', 'beautifier', 'formatter', 'prettify']
      },
      {
        id: 'php-formatter',
        name: 'PHP Formatter',
        path: '/tools/php-formatter',
        description: 'Format and beautify PHP code with proper indentation',
        keywords: ['php', 'formatter', 'beautifier', 'prettify']
      },
      {
        id: 'python-formatter',
        name: 'Python Formatter',
        path: '/tools/python-formatter',
        description: 'Format Python code according to PEP 8 style guide',
        keywords: ['python', 'formatter', 'pep8', 'beautifier']
      },
      {
        id: 'graphql-formatter',
        name: 'GraphQL Formatter',
        path: '/tools/graphql-formatter',
        description: 'Format and validate GraphQL queries and schemas',
        keywords: ['graphql', 'formatter', 'validator', 'beautifier']
      },
      {
        id: 'typescript-formatter',
        name: 'TypeScript Formatter',
        path: '/tools/typescript-formatter',
        description: 'Format TypeScript code with proper type annotations',
        keywords: ['typescript', 'formatter', 'beautifier', 'ts']
      },
      {
        id: 'markdown-formatter',
        name: 'Markdown Formatter',
        path: '/tools/markdown-formatter',
        description: 'Format and beautify Markdown documents',
        keywords: ['markdown', 'formatter', 'beautifier', 'md']
      },
      // Existing developer tools
      {
        id: 'base64',
        name: 'Base64 Encoder/Decoder',
        description: 'Encode and decode Base64 strings and files with ease',
        path: '/tools/base64',
        keywords: ['base64', 'encode', 'decode', 'converter', 'file', 'text']
      },
      {
        id: 'regex-tester',
        name: 'Regex Tester',
        description: 'Test, debug, and learn regular expressions with real-time matching',
        path: '/tools/regex',
        keywords: ['regex', 'regular expression', 'pattern matching', 'test', 'debug']
      },
      {
        id: 'color-picker',
        name: 'Color Picker',
        description: 'Generate, convert, and analyze color codes with contrast checking',
        path: '/tools/color-picker',
        keywords: ['color', 'picker', 'converter', 'hex', 'rgb', 'hsl', 'contrast', 'palette']
      },
      {
        id: 'markdown-editor',
        name: 'Markdown Editor',
        description: 'Feature-rich markdown editor with live preview and export options',
        path: '/tools/markdown-editor',
        keywords: ['markdown', 'editor', 'preview', 'export', 'html', 'converter']
      },
      {
        id: 'cron-scheduler',
        name: 'Cron Job Scheduler',
        description: 'Generate, validate, and understand cron expressions with visual preview and next run times',
        path: '/tools/cron-scheduler',
        keywords: ['cron', 'scheduler', 'cron expression', 'job scheduler', 'automation', 'time']
      }
    ]
  },

  // Data Conversion
  {
    id: 'conversion',
    name: 'Data Conversion',
    description: 'Convert between different data formats and encodings',
    icon: '🔄',
    tools: [
      // Encoding/Decoding
      {
        id: 'url-encoder',
        name: 'URL Encode/Decode',
        path: '/tools/url-encode',
        description: 'Encode or decode URL-encoded strings',
        keywords: ['url', 'encode', 'decode', 'percent', 'escape']
      },
      {
        id: 'html-escape',
        name: 'HTML Escape/Unescape',
        path: '/tools/html-escape',
        description: 'Escape or unescape HTML entities',
        keywords: ['html', 'escape', 'unescape', 'entities', 'special characters']
      },
      {
        id: 'json-escape',
        name: 'JSON Escape/Unescape',
        path: '/tools/json-escape',
        description: 'Escape or unescape JSON strings',
        keywords: ['json', 'escape', 'unescape', 'string', 'format']
      },
      {
        id: 'utf8-encode',
        name: 'UTF-8 Encode/Decode',
        path: '/tools/utf8-encode',
        description: 'Encode or decode UTF-8 strings',
        keywords: ['utf8', 'encode', 'decode', 'unicode', 'text']
      },

      // Format Converters
      {
        id: 'json-to-xml',
        name: 'JSON to XML',
        path: '/tools/json-to-xml',
        description: 'Convert JSON data to XML format',
        keywords: ['json', 'xml', 'convert', 'transform', 'data']
      },
      {
        id: 'xml-to-json',
        name: 'XML to JSON',
        path: '/tools/xml-to-json',
        description: 'Convert XML data to JSON format',
        keywords: ['xml', 'json', 'convert', 'transform', 'data']
      },
      {
        id: 'json-to-yaml',
        name: 'JSON to YAML',
        path: '/tools/json-to-yaml',
        description: 'Convert JSON data to YAML format',
        keywords: ['json', 'yaml', 'convert', 'transform', 'data']
      },
      {
        id: 'yaml-to-json',
        name: 'YAML to JSON',
        path: '/tools/yaml-to-json',
        description: 'Convert YAML data to JSON format',
        keywords: ['yaml', 'json', 'convert', 'transform', 'data']
      },
      {
        id: 'csv-to-json',
        name: 'CSV to JSON',
        path: '/tools/csv-to-json',
        description: 'Convert CSV data to JSON format',
        keywords: ['csv', 'json', 'convert', 'spreadsheet', 'table']
      },
      {
        id: 'json-to-csv',
        name: 'JSON to CSV',
        path: '/tools/json-to-csv',
        description: 'Convert JSON data to CSV format',
        keywords: ['json', 'csv', 'convert', 'spreadsheet', 'table']
      },
      {
        id: 'csv-to-tsv',
        name: 'CSV to TSV',
        path: '/tools/csv-to-tsv',
        description: 'Convert CSV to TSV (Tab-Separated Values)',
        keywords: ['csv', 'tsv', 'convert', 'tab', 'spreadsheet']
      },
      {
        id: 'tsv-to-csv',
        name: 'TSV to CSV',
        path: '/tools/tsv-to-csv',
        description: 'Convert TSV (Tab-Separated Values) to CSV',
        keywords: ['tsv', 'csv', 'convert', 'tab', 'spreadsheet']
      },
      {
        id: 'json-to-tsv',
        name: 'JSON to TSV',
        path: '/tools/json-to-tsv',
        description: 'Convert JSON data to TSV (Tab-Separated Values)',
        keywords: ['json', 'tsv', 'convert', 'tab', 'table']
      },
      {
        id: 'xml-to-yaml',
        name: 'XML to YAML',
        path: '/tools/xml-to-yaml',
        description: 'Convert XML data to YAML format',
        keywords: ['xml', 'yaml', 'convert', 'transform', 'data']
      },
      {
        id: 'yaml-to-xml',
        name: 'YAML to XML',
        path: '/tools/yaml-to-xml',
        description: 'Convert YAML data to XML format',
        keywords: ['yaml', 'xml', 'convert', 'transform', 'data']
      },
      {
        id: 'html-to-markdown',
        name: 'HTML to Markdown',
        path: '/tools/html-to-markdown',
        description: 'Convert HTML to Markdown format',
        keywords: ['html', 'markdown', 'convert', 'transform', 'md']
      },
      {
        id: 'markdown-to-html',
        name: 'Markdown to HTML',
        path: '/tools/markdown-to-html',
        description: 'Convert Markdown to HTML',
        keywords: ['markdown', 'html', 'convert', 'transform', 'md']
      }
    ]
  },

  // Hash & Encryption
  {
    id: 'hash-calculators',
    name: 'Hash & Encryption',
    description: 'Generate hashes and perform encryption',
    icon: '🔒',
    tools: [
      // Hash Generators
      {
        id: 'hash-generator',
        name: 'Hash Generator',
        path: '/tools/hash-generator',
        description: 'Generate multiple hash types (MD5, SHA-1, SHA-256, SHA-512) from text',
        keywords: ['hash', 'generator', 'md5', 'sha1', 'sha256', 'sha512', 'checksum']
      },
      {
        id: 'md5-hash',
        name: 'MD5 Hash',
        path: '/tools/md5-hash',
        description: 'Generate MD5 hash from text',
        keywords: ['md5', 'hash', 'digest', 'cryptography', 'checksum']
      },
      {
        id: 'sha1-hash',
        name: 'SHA-1 Hash',
        path: '/tools/sha1-hash',
        description: 'Generate SHA-1 hash from text',
        keywords: ['sha1', 'hash', 'digest', 'cryptography', 'checksum']
      },
      {
        id: 'sha256-hash',
        name: 'SHA-256 Hash',
        path: '/tools/sha256-hash',
        description: 'Generate SHA-256 hash from text',
        keywords: ['sha256', 'hash', 'digest', 'cryptography', 'checksum']
      },
      {
        id: 'sha512-hash',
        name: 'SHA-512 Hash',
        path: '/tools/sha512-hash',
        description: 'Generate SHA-512 hash from text',
        keywords: ['sha512', 'hash', 'digest', 'cryptography', 'checksum']
      },
      {
        id: 'hmac-generator',
        name: 'HMAC Generator',
        path: '/tools/hmac-generator',
        description: 'Generate HMAC (Hash-based Message Authentication Code)',
        keywords: ['hmac', 'hash', 'mac', 'authentication', 'cryptography']
      },
      {
        id: 'bcrypt-generator',
        name: 'Bcrypt Generator',
        path: '/tools/bcrypt-generator',
        description: 'Generate Bcrypt hashes for password storage',
        keywords: ['bcrypt', 'hash', 'password', 'security', 'authentication']
      },
      {
        id: 'crc32-hash',
        name: 'CRC32 Hash',
        path: '/tools/crc32-hash',
        description: 'Generate CRC32 checksum from text',
        keywords: ['crc32', 'checksum', 'hash', 'error detection']
      },
      {
        id: 'ntlm-hash',
        name: 'NTLM Hash',
        path: '/tools/ntlm-hash',
        description: 'Generate NTLM hash from text',
        keywords: ['ntlm', 'hash', 'windows', 'authentication']
      },
      {
        id: 'whirlpool-hash',
        name: 'Whirlpool Hash',
        path: '/tools/whirlpool-hash',
        description: 'Generate Whirlpool hash from text',
        keywords: ['whirlpool', 'hash', 'digest', 'cryptography']
      },
      {
        id: 'ripemd-hash',
        name: 'RIPEMD Hash',
        path: '/tools/ripemd-hash',
        description: 'Generate RIPEMD hash from text',
        keywords: ['ripemd', 'hash', 'digest', 'cryptography']
      },
      {
        id: 'adler32-hash',
        name: 'Adler32 Hash',
        path: '/tools/adler32-hash',
        description: 'Generate Adler32 checksum from text',
        keywords: ['adler32', 'checksum', 'hash', 'error detection']
      },
      {
        id: 'gost-hash',
        name: 'GOST Hash',
        path: '/tools/gost-hash',
        description: 'Generate GOST hash from text',
        keywords: ['gost', 'hash', 'digest', 'cryptography']
      },
      {
        id: 'shake256-hash',
        name: 'SHAKE-256',
        path: '/tools/shake256-hash',
        description: 'Generate SHAKE-256 hash from text',
        keywords: ['shake256', 'hash', 'digest', 'cryptography']
      },
      // Encryption
      {
        id: 'aes-encrypt',
        name: 'AES Encryption',
        path: '/tools/aes-encrypt',
        description: 'Encrypt and decrypt text using AES algorithm',
        keywords: ['aes', 'encryption', 'decryption', 'cipher', 'cryptography']
      },
      {
        id: 'des-encrypt',
        name: 'DES Encryption',
        path: '/tools/des-encrypt',
        description: 'Encrypt and decrypt text using DES algorithm',
        keywords: ['des', 'encryption', 'decryption', 'cipher', 'cryptography']
      },
      {
        id: 'rsa-generator',
        name: 'RSA Key Generator',
        path: '/tools/rsa-generator',
        description: 'Generate RSA public and private key pairs',
        keywords: ['rsa', 'key', 'generator', 'public key', 'private key', 'cryptography']
      },
      {
        id: 'jwt-decoder',
        name: 'JWT Decoder',
        path: '/tools/jwt-decoder',
        description: 'Decode and verify JSON Web Tokens (JWT)',
        keywords: ['jwt', 'json web token', 'decode', 'verify', 'authentication']
      },
      {
        id: 'saml-decoder',
        name: 'SAML Decoder',
        path: '/tools/saml-decoder',
        description: 'Decode and validate SAML responses',
        keywords: ['saml', 'decode', 'validate', 'authentication', 'sso']
      }
    ]
  },

  // Text & String
  {
    id: 'text-tools',
    name: 'Text & String',
    description: 'Tools for text manipulation and analysis',
    icon: '📝',
    tools: [
      {
        id: 'character-counter',
        name: 'Character Counter',
        path: '/tools/character-counter',
        description: 'Count characters, words, and lines in text',
        keywords: ['character', 'counter', 'text', 'length', 'count']
      },
      {
        id: 'text-editor',
        name: 'Text Editor',
        path: '/tools/text-editor',
        description: 'Write, edit, and format text with rich features and statistics',
        keywords: ['text editor', 'editor', 'writing', 'formatting', 'statistics', 'word count']
      },
      {
        id: 'line-counter',
        name: 'Line Counter',
        path: '/tools/line-counter',
        description: 'Count the number of lines in text',
        keywords: ['line', 'counter', 'count', 'text', 'newline']
      },
      {
        id: 'sentence-counter',
        name: 'Sentence Counter',
        path: '/tools/sentence-counter',
        description: 'Count sentences in text',
        keywords: ['sentence', 'counter', 'text', 'count', 'period']
      },
      {
        id: 'paragraph-counter',
        name: 'Paragraph Counter',
        path: '/tools/paragraph-counter',
        description: 'Count paragraphs in text',
        keywords: ['paragraph', 'counter', 'text', 'count', 'newline']
      },
      {
        id: 'keyword-density',
        name: 'Keyword Density',
        path: '/tools/keyword-density',
        description: 'Analyze keyword density in text',
        keywords: ['keyword', 'density', 'seo', 'analysis', 'frequency']
      },
      {
        id: 'text-stats',
        name: 'Text Statistics',
        path: '/tools/text-stats',
        description: 'Get detailed statistics about text',
        keywords: ['text', 'statistics', 'analysis', 'count', 'metrics']
      },

      // Text Transformation
      {
        id: 'text-case-converter',
        name: 'Text Case Converter',
        path: '/tools/text-case-converter',
        description: 'Convert text between different cases (camelCase, snake_case, etc.)',
        keywords: ['text', 'case', 'converter', 'transform', 'format']
      },
      {
        id: 'text-reverser',
        name: 'Text Reverser',
        path: '/tools/text-reverser',
        description: 'Reverse text or strings',
        keywords: ['text', 'reverse', 'string', 'backwards', 'invert']
      },
      {
        id: 'text-sorter',
        name: 'Text Sorter',
        path: '/tools/text-sorter',
        description: 'Sort lines of text alphabetically or numerically',
        keywords: ['text', 'sort', 'alphabetical', 'order', 'arrange']
      },
      {
        id: 'text-comparer',
        name: 'Text Comparer',
        path: '/tools/text-comparer',
        description: 'Compare two texts and find differences',
        keywords: ['text', 'compare', 'diff', 'difference', 'comparison']
      },
      {
        id: 'text-deduplicator',
        name: 'Text Deduplicator',
        path: '/tools/text-deduplicator',
        description: 'Remove duplicate lines from text',
        keywords: ['text', 'deduplicate', 'remove', 'duplicates', 'unique']
      },
      {
        id: 'text-extractor',
        name: 'Text Extractor',
        path: '/tools/text-extractor',
        description: 'Extract specific parts of text using patterns',
        keywords: ['text', 'extract', 'pattern', 'regex', 'parse']
      },
      {
        id: 'text-replacer',
        name: 'Text Replacer',
        path: '/tools/text-replacer',
        description: 'Find and replace text with support for regex',
        keywords: ['text', 'replace', 'find', 'regex', 'substitute']
      },
      {
        id: 'text-splitter',
        name: 'Text Splitter',
        path: '/tools/text-splitter',
        description: 'Split text by delimiter or pattern',
        keywords: ['text', 'split', 'divide', 'separate', 'delimiter']
      },
      {
        id: 'text-joiner',
        name: 'Text Joiner',
        path: '/tools/text-joiner',
        description: 'Join multiple text pieces with a delimiter',
        keywords: ['text', 'join', 'combine', 'merge', 'concatenate']
      }
    ]
  },

  // Random Generators
  {
    id: 'random-generators',
    name: 'Random Generators',
    description: 'Generate random data for testing and development',
    icon: '🎲',
    tools: [
      // Random Data
      {
        id: 'random-json',
        name: 'Random JSON',
        path: '/tools/random-json',
        description: 'Generate random JSON data',
        keywords: ['random', 'json', 'data', 'generator', 'test']
      },
      {
        id: 'random-xml',
        name: 'Random XML',
        path: '/tools/random-xml',
        description: 'Generate random XML data',
        keywords: ['random', 'xml', 'data', 'generator', 'test']
      },
      {
        id: 'random-csv',
        name: 'Random CSV',
        path: '/tools/random-csv',
        description: 'Generate random CSV data',
        keywords: ['random', 'csv', 'data', 'generator', 'test', 'spreadsheet']
      },
      {
        id: 'random-tsv',
        name: 'Random TSV',
        path: '/tools/random-tsv',
        description: 'Generate random TSV (Tab-Separated Values) data',
        keywords: ['random', 'tsv', 'data', 'generator', 'test', 'tab']
      },
      {
        id: 'random-yaml',
        name: 'Random YAML',
        path: '/tools/random-yaml',
        description: 'Generate random YAML data',
        keywords: ['random', 'yaml', 'data', 'generator', 'test']
      },
      {
        id: 'random-sql',
        name: 'Random SQL',
        path: '/tools/random-sql',
        description: 'Generate random SQL queries',
        keywords: ['random', 'sql', 'query', 'database', 'test']
      },
      {
        id: 'random-string',
        name: 'Random String',
        path: '/tools/random-string',
        description: 'Generate random strings with custom options',
        keywords: ['random', 'string', 'text', 'generator', 'password']
      },
      {
        id: 'random-number',
        name: 'Random Number',
        path: '/tools/random-number',
        description: 'Generate random numbers within a range',
        keywords: ['random', 'number', 'integer', 'float', 'range']
      },
      {
        id: 'random-color',
        name: 'Random Color',
        path: '/tools/random-color',
        description: 'Generate random colors in different formats',
        keywords: ['random', 'color', 'hex', 'rgb', 'hsl']
      },
      {
        id: 'random-date',
        name: 'Random Date',
        path: '/tools/random-date',
        description: 'Generate random dates within a range',
        keywords: ['random', 'date', 'time', 'generator', 'range']
      },
      {
        id: 'random-boolean',
        name: 'Random Boolean',
        path: '/tools/random-boolean',
        description: 'Generate random true/false values',
        keywords: ['random', 'boolean', 'true', 'false', 'generator']
      },
      {
        id: 'random-ip',
        name: 'Random IP',
        path: '/tools/random-ip',
        description: 'Generate random IP addresses (IPv4 or IPv6)',
        keywords: ['random', 'ip', 'address', 'ipv4', 'ipv6', 'network']
      },
      {
        id: 'random-mac',
        name: 'Random MAC',
        path: '/tools/random-mac',
        description: 'Generate random MAC addresses',
        keywords: ['random', 'mac', 'address', 'network', 'hardware']
      },
      {
        id: 'random-uuid',
        name: 'Random UUID',
        path: '/tools/random-uuid',
        description: 'Generate random UUIDs (v4)',
        keywords: ['random', 'uuid', 'guid', 'unique', 'identifier']
      },
      {
        id: 'random-password',
        name: 'Random Password',
        path: '/tools/random-password',
        description: 'Generate secure random passwords',
        keywords: ['random', 'password', 'generator', 'security', 'strong']
      },
      {
        id: 'random-username',
        name: 'Random Username',
        path: '/tools/random-username',
        description: 'Generate random usernames',
        keywords: ['random', 'username', 'nickname', 'alias', 'generator']
      },
      {
        id: 'random-name',
        name: 'Random Name',
        path: '/tools/random-name',
        description: 'Generate random names (first and last)',
        keywords: ['random', 'name', 'person', 'generator', 'fake']
      },
      {
        id: 'random-address',
        name: 'Random Address',
        path: '/tools/random-address',
        description: 'Generate random street addresses',
        keywords: ['random', 'address', 'location', 'street', 'generator']
      },
      {
        id: 'random-phone',
        name: 'Random Phone',
        path: '/tools/random-phone',
        description: 'Generate random phone numbers',
        keywords: ['random', 'phone', 'number', 'telephone', 'generator']
      },
      {
        id: 'random-email',
        name: 'Random Email',
        path: '/tools/random-email',
        description: 'Generate random email addresses',
        keywords: ['random', 'email', 'address', 'generator', 'fake']
      },
      {
        id: 'random-credit-card',
        name: 'Random Credit Card',
        path: '/tools/random-credit-card',
        description: 'Generate random credit card numbers for testing',
        keywords: ['random', 'credit card', 'payment', 'test', 'number']
      },
      {
        id: 'random-lorem-ipsum',
        name: 'Random Lorem Ipsum',
        path: '/tools/random-lorem-ipsum',
        description: 'Generate random lorem ipsum placeholder text',
        keywords: ['random', 'lorem', 'ipsum', 'text', 'placeholder']
      }
    ]
  },

  // Business & Finance
  {
    id: 'business',
    name: 'Business & Finance',
    description: 'Financial calculators and business tools',
    icon: '💼',
    tools: [
      {
        id: 'invoice-generator',
        name: 'Invoice Generator',
        description: 'Create and customize professional invoices in minutes',
        path: '/tools/invoice-generator',
        keywords: ['invoice', 'billing', 'business', 'finance', 'generator', 'pdf']
      },
      {
        id: 'salary-calculator',
        name: 'Salary Calculator',
        description: 'Calculate take-home pay, taxes, and deductions',
        path: '/tools/salary-calculator',
        keywords: ['salary', 'tax', 'income', 'calculator', 'paycheck', 'deductions']
      },
      {
        id: 'roi-calculator',
        name: 'ROI Calculator',
        description: 'Calculate return on investment with detailed analysis',
        path: '/tools/roi-calculator',
        keywords: ['roi', 'investment', 'calculator', 'finance', 'return', 'business']
      },
      {
        id: 'vat-calculator',
        name: 'VAT Calculator',
        description: 'Calculate VAT, gross, and net amounts',
        path: '/tools/vat-calculator',
        keywords: ['vat', 'tax', 'calculator', 'sales tax', 'gst']
      }
    ]
  },
  // Content & Marketing
  {
    id: 'content',
    name: 'Content & Marketing',
    description: 'Tools for content creators and digital marketers',
    icon: '📢',
    tools: [
      {
        id: 'youtube-title-generator',
        name: 'YouTube Title Generator',
        description: 'Generate high-CTR titles for YouTube videos',
        path: '/tools/youtube-title-generator',
        keywords: ['youtube', 'title', 'generator', 'video', 'ctr', 'click-through']
      },
      {
        id: 'hashtag-generator',
        name: 'Hashtag Generator',
        description: 'Find trending and relevant hashtags for all social platforms',
        path: '/tools/hashtag-generator',
        keywords: ['hashtag', 'social media', 'instagram', 'twitter', 'tiktok', 'trending']
      },
      {
        id: 'seo-meta-generator',
        name: 'SEO Meta Generator',
        description: 'Create optimized meta tags, titles, and descriptions',
        path: '/tools/seo-meta-generator',
        keywords: ['seo', 'meta', 'generator', 'search engine', 'snippet', 'sitemap']
      },
      {
        id: 'blog-idea-generator',
        name: 'Blog Idea Generator',
        description: 'Discover engaging blog post ideas and topics',
        path: '/tools/blog-idea-generator',
        keywords: ['blog', 'ideas', 'content', 'topics', 'generator']
      },
      {
        id: 'instagram-title-generator',
        name: 'Instagram Caption Generator',
        description: 'Create engaging Instagram captions with emojis and hashtags',
        path: '/tools/instagram-title-generator',
        keywords: ['instagram', 'caption', 'generator', 'social media', 'hashtags', 'emojis']
      },
      {
        id: 'facebook-title-generator',
        name: 'Facebook Post Generator',
        description: 'Create engaging Facebook posts for any occasion',
        path: '/tools/facebook-title-generator',
        keywords: ['facebook', 'post', 'generator', 'social media', 'captions', 'content']
      },
      {
        id: 'email-template-builder',
        name: 'Email Template Builder',
        description: 'Create professional email templates for various purposes',
        path: '/tools/email-template-builder',
        keywords: ['email', 'template', 'builder', 'professional', 'marketing']
      }
    ]
  },
  // Design & Media
  {
    id: 'design',
    name: 'Design & Media',
    description: 'Creative tools for designers and media professionals',
    icon: '🎨',
    tools: [
      {
        id: 'image-compressor',
        name: 'Image Compressor',
        description: 'Compress and optimize images while preserving quality',
        path: '/tools/image-compressor',
        keywords: ['image', 'compressor', 'optimize', 'resize', 'jpeg', 'png', 'webp']
      },
      {
        id: 'qr-code-generator',
        name: 'QR Code Generator',
        description: 'Create custom QR codes with colors, logos, and tracking',
        path: '/tools/qr-code-generator',
        keywords: ['qr code', 'generator', 'barcode', 'scan', 'download', 'custom']
      },
      {
        id: 'favicon-generator',
        name: 'Favicon Generator',
        description: 'Create and customize favicons for all devices',
        path: '/tools/favicon-generator',
        keywords: ['favicon', 'generator', 'icon', 'website', 'browser tab']
      },
      {
        id: 'color-palette-generator',
        name: 'Color Palette Generator',
        description: 'Create beautiful color schemes and palettes',
        path: '/tools/color-palette',
        keywords: ['color', 'palette', 'scheme', 'generator', 'design']
      }
    ]
  },
  // Education & Learning
  {
    id: 'education',
    name: 'Education',
    description: 'Learning and academic support tools',
    icon: '📚',
    tools: [
      {
        id: 'word-counter',
        name: 'Word Counter',
        description: 'Count words, characters, sentences, and reading time',
        path: '/tools/word-counter',
        keywords: ['word', 'counter', 'character', 'reading time', 'text analysis']
      },
      {
        id: 'citation-generator',
        name: 'Citation Generator',
        description: 'Generate citations in APA, MLA, Chicago, and more',
        path: '/tools/citation-generator',
        keywords: ['citation', 'reference', 'apa', 'mla', 'chicago', 'harvard', 'ieee']
      },
      {
        id: 'plagiarism-checker',
        name: 'Plagiarism Checker',
        description: 'Detect potential plagiarism and duplicate content',
        path: '/tools/plagiarism-checker',
        keywords: ['plagiarism', 'checker', 'duplicate', 'content', 'academic']
      },
      {
        id: 'spell-checker',
        name: 'Grammar & Spell Checker',
        description: 'Check spelling and grammar in your text',
        path: '/tools/spell-checker',
        keywords: ['spell', 'grammar', 'checker', 'proofread', 'writing']
      },
      {
        id: 'typing-speed-test',
        name: 'Typing Speed Test',
        description: 'Test and improve your typing speed and accuracy',
        path: '/tools/typing-speed-test',
        keywords: ['typing', 'speed', 'test', 'wpm', 'accuracy', 'keyboard']
      }
    ]
  },
  // Web & SEO
  {
    id: 'web-seo',
    name: 'Web & SEO',
    description: 'Website analysis and search engine optimization tools',
    icon: '🔍',
    tools: [
      {
        id: 'seo-analyzer',
        name: 'SEO Analyzer',
        description: 'Comprehensive website SEO analysis and recommendations',
        path: '/tools/seo-analyzer',
        keywords: ['seo', 'analyzer', 'website', 'ranking', 'optimization']
      },
      {
        id: 'backlink-checker',
        name: 'Backlink Checker',
        description: 'Analyze backlinks for any website with detailed metrics',
        path: '/tools/backlink-checker',
        keywords: ['backlink', 'checker', 'seo', 'links', 'domain authority']
      },
      {
        id: 'website-speed-test',
        name: 'Website Speed Test',
        description: 'Test and optimize your website loading speed',
        path: '/tools/speed-test',
        keywords: ['speed', 'performance', 'website', 'pagespeed', 'gtmetrix']
      },
      {
        id: 'sitemap-generator',
        name: 'Sitemap Generator',
        description: 'Generate XML sitemaps for any website to improve SEO',
        path: '/tools/sitemap-generator',
        keywords: ['sitemap', 'xml', 'seo', 'search engine', 'website', 'crawler']
      }
    ]
  },
  // Health & Wellness
  {
    id: 'health',
    name: 'Health & Wellness',
    description: 'Health, fitness, and wellness calculators',
    icon: '❤️',
    tools: [
      {
        id: 'bmi-calculator',
        name: 'BMI Calculator',
        description: 'Calculate your Body Mass Index and ideal weight range',
        path: '/bmi-calculator',
        keywords: ['bmi', 'calculator', 'health', 'weight', 'body mass index']
      },
      {
        id: 'body-fat-calculator',
        name: 'Body Fat Calculator',
        description: 'Calculate your body fat percentage using the US Navy formula',
        path: '/tools/body-fat-calculator',
        keywords: ['body fat', 'calculator', 'percentage', 'navy formula', 'fitness', 'health']
      },
      {
        id: 'ideal-weight',
        name: 'Ideal Weight Calculator',
        description: 'Calculate your ideal weight using multiple proven formulas',
        path: '/tools/ideal-weight',
        keywords: ['ideal weight', 'calculator', 'healthy weight', 'devine formula', 'robinson formula']
      },
      {
        id: 'calorie-calculator',
        name: 'Calorie Calculator',
        description: 'Calculate daily calorie needs based on your goals',
        path: '/tools/calorie-calculator',
        keywords: ['calorie', 'diet', 'nutrition', 'calculator', 'macros']
      },
      {
        id: 'water-intake-calculator',
        name: 'Water Intake Calculator',
        description: 'Calculate your daily recommended water intake',
        path: '/tools/water-calculator',
        keywords: ['water', 'intake', 'hydration', 'calculator', 'daily']
      },
      {
        id: 'sleep-calculator',
        name: 'Sleep Calculator',
        description: 'Optimize your sleep schedule for better rest',
        path: '/tools/sleep-calculator',
        keywords: ['sleep', 'calculator', 'rem', 'circadian', 'rest']
      }
    ]
  },
  // Personal Finance
  {
    id: 'finance',
    name: 'Personal Finance',
    description: 'Financial planning and money management tools',
    icon: '💰',
    tools: [
      {
        id: 'emi-calculator',
        name: 'EMI Calculator',
        description: 'Calculate loan EMIs, interest, and payment schedules',
        path: '/emi-calculator',
        keywords: ['emi', 'loan', 'calculator', 'finance', 'mortgage', 'payment']
      },
      {
        id: 'savings-calculator',
        name: 'Savings Calculator',
        description: 'Plan and project your savings and investment growth',
        path: '/tools/savings-calculator',
        keywords: ['savings', 'calculator', 'investment', 'finance', 'retirement']
      },
      {
        id: 'currency-converter',
        name: 'Currency Converter',
        description: 'Convert between world currencies with live exchange rates',
        path: '/tools/currency-converter',
        keywords: ['currency', 'converter', 'money', 'exchange', 'forex', 'rates']
      },
      {
        id: 'debt-payoff-calculator',
        name: 'Debt Payoff Calculator',
        description: 'Create a plan to pay off your debt faster',
        path: '/tools/debt-calculator',
        keywords: ['debt', 'calculator', 'payoff', 'snowball', 'avalanche']
      }
    ]
  },
  // Productivity & Utilities
  {
    id: 'productivity',
    name: 'Productivity',
    description: 'Tools to boost your efficiency and organization',
    icon: '⚡',
    tools: [
      {
        id: 'pomodoro-timer',
        name: 'Pomodoro Timer',
        description: 'Boost productivity with the Pomodoro technique',
        path: '/tools/pomodoro-timer',
        keywords: ['pomodoro', 'timer', 'productivity', 'focus', 'work']
      },
      {
        id: 'to-do-list',
        name: 'To-Do List',
        description: 'Organize and prioritize your daily tasks',
        path: '/tools/todo-list',
        keywords: ['todo', 'task', 'planner', 'organizer', 'productivity']
      },
      {
        id: 'password-generator',
        name: 'Password Generator',
        description: 'Generate and manage strong, secure passwords',
        path: '/tools/password-generator',
        keywords: ['password', 'generator', 'security', 'privacy', 'manager']
      },
      {
        id: 'note-taking',
        name: 'Note Taking',
        description: 'Take and organize your notes in markdown',
        path: '/tools/notes',
        keywords: ['notes', 'markdown', 'organize', 'productivity']
      }
    ]
  },
  // Personal Utilities
  {
    id: 'personal-utilities',
    name: 'Personal Utilities',
    description: 'Everyday utilities for personal use and convenience',
    icon: '🛠️',
    tools: [
      {
        id: 'date-difference',
        name: 'Date Difference Calculator',
        description: 'Calculate the difference between two dates with detailed breakdown',
        path: '/tools/date-difference',
        keywords: ['date', 'difference', 'calculator', 'duration', 'time span', 'days between']
      },
      {
        id: 'birthday-countdown',
        name: 'Birthday Countdown',
        description: 'Count down to your next birthday and calculate age details',
        path: '/tools/birthday-countdown',
        keywords: ['birthday', 'countdown', 'age', 'timer', 'celebration', 'days until']
      },
      {
        id: 'time-zone-converter',
        name: 'Time Zone Converter',
        description: 'Convert time between different time zones worldwide',
        path: '/tools/time-zone-converter',
        keywords: ['time zone', 'converter', 'world clock', 'utc', 'timezone', 'international time']
      }
    ]
  }
];

// Helper function to get all tools in a flat array
export const allTools = toolCategories.flatMap(category =>
  category.tools.map(tool => ({
    ...tool,
    category: category.name,
    categoryId: category.id
  }))
);

// Featured tools for the homepage
export const featuredTools = [
  allTools.find(tool => tool.id === 'bmi-calculator'),
  allTools.find(tool => tool.id === 'json-formatter'),
  allTools.find(tool => tool.id === 'youtube-title-generator'),
  allTools.find(tool => tool.id === 'password-generator'),
  allTools.find(tool => tool.id === 'image-compressor'),
  allTools.find(tool => tool.id === 'seo-analyzer'),
  allTools.find(tool => tool.id === 'currency-converter'),
  allTools.find(tool => tool.id === 'pomodoro-timer')
].filter(Boolean);